import { FC, memo } from 'react'
import styled from 'styled-components'
import { Heading } from '@ucheba/ui/components/Heading/desktop'
import { Text } from '@ucheba/ui/components/Text/desktop'
import { IProgramIdPageProfilesProps } from '../types'

const Block = styled.div``

const ProgramIdPageProfiles: FC<IProgramIdPageProfilesProps> = (props) => {
  const { text } = props

  if (!text) return null

  return (
    <Block>
      <Heading h3='Профили обучения' spacing='small' />

      <Text>{text}</Text>
    </Block>
  )
}

export default memo(ProgramIdPageProfiles)
